import type { Chat, LinkChatToDocumentArgs } from '@ztechapps/common.contract'
import { useActionMutation } from '@ztechapps/common.hook'
import { linkChatToDocumentMutation } from '../Inbox/graphql'

export type UseLinkChatToDocumentResult = [
  linkChatToDocument: (input: LinkChatToDocumentArgs) => Promise<Chat>,
  { loading: boolean },
]

// Attaches an existing conversation to a document. A refused link (no edit permission, a document of another
// tenant) rejects and is not caught here: the picker's form toasts it once and stays open, so a second
// `useError` toast would double it. The response's `metadata` and `document` update the cached chat.
export const useLinkChatToDocument = (): UseLinkChatToDocumentResult => {
  const [linkChatToDocument, { loading }] = useActionMutation<Chat, LinkChatToDocumentArgs>({
    query: linkChatToDocumentMutation,
  })

  return [linkChatToDocument, { loading }]
}
